/* Caviar Centre cart complements. Only explicit customer clicks add items. */
(() => {
  'use strict';
  if (customElements.get('cc-cart-complements')) return;
  let busy = false;
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const route = (path) => root().replace(/\/$/, '') + '/' + path;
  const contextURL = () => {
    const u = new URL(window.location.href);
    u.searchParams.delete('section_id');
    u.searchParams.delete('sections');
    return u;
  };
  const goToCart = () => {
    const u = new URL(route('cart'), window.location.origin);
    const preview = contextURL().searchParams.get('preview_theme_id');
    if (preview) u.searchParams.set('preview_theme_id', preview);
    window.location.assign(u.pathname + u.search);
  };
  const containsProduct = (items, productID) => Array.isArray(items) && items.some(item =>
    String(item.product_id || (item.product && item.product.id)) === productID ||
    containsProduct(item.item_components, productID)
  );
  const setBusy = (value) => {
    busy = value;
    document.querySelectorAll('cc-cart-complements').forEach(el => {
      el.setAttribute('aria-busy', String(value));
      el.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = value; });
    });
  };
  const announce = (message) => {
    let region = document.getElementById('cc-cart-complements-live');
    if (!region) {
      region = document.createElement('div');
      region.id = 'cc-cart-complements-live';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = message;
  };
  const getSection = async () => {
    const u = contextURL();
    u.searchParams.set('section_id', 'helper-cart');
    const response = await fetch(u.pathname + u.search, {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('Cart refresh failed');
    return response.text();
  };
  const renderCart = async (html) => {
    if (!html) html = await getSection();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextForm = doc.getElementById('AjaxCartForm');
    const nextSubtotal = doc.getElementById('AjaxCartSubtotal');
    const form = document.getElementById('AjaxCartForm');
    const subtotal = document.getElementById('AjaxCartSubtotal');
    if (!nextForm || !nextSubtotal || !form || !subtotal || typeof form.ajaxifyCartItems !== 'function') {
      throw new Error('Cart components missing');
    }
    form.innerHTML = nextForm.innerHTML;
    form.ajaxifyCartItems();
    subtotal.innerHTML = nextSubtotal.innerHTML;
    const count = form.querySelector('[data-cart-count]');
    const total = form.querySelector('[data-cart-total]');
    if (count) document.querySelectorAll('[data-header-cart-count]').forEach(el => {el.textContent = count.textContent;});
    if (total) document.querySelectorAll('[data-header-cart-total]').forEach(el => {el.textContent = total.textContent;});
    form.dispatchEvent(new Event('cart-updated', {bubbles:true}));
  };
  class CCCartComplements extends HTMLElement {
    connectedCallback() {
      if (!this.onSubmit) this.onSubmit = this.submit.bind(this);
      this.addEventListener('submit', this.onSubmit);
    }
    disconnectedCallback() { this.removeEventListener('submit', this.onSubmit); }
    message(text) {
      const status = this.querySelector('.cc-complements-status');
      if (status) {status.textContent = text;status.hidden = false;}
    }
    async submit(event) {
      const form = event.target.closest('[data-cc-complement-form]');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      if (busy) return;
      if (document.querySelector('cart-form form.processing')) {
        this.message(this.dataset.wait);
        return;
      }
      const errorText = this.dataset.error;
      const successText = this.dataset.added;
      const variantID = String(new FormData(form).get('id') || '');
      const productID = form.dataset.productId;
      if (!/^\d+$/.test(variantID) || !/^\d+$/.test(productID || '')) return;
      setBusy(true);
      let requestSent = false;
      let mutationConfirmed = false;
      try {
        const current = await fetch(route('cart.js'), {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if (!current.ok) throw new Error(errorText);
        const cart = await current.json();
        if (containsProduct(cart.items, productID)) {
          await renderCart();
          return;
        }
        const context = contextURL();
        requestSent = true;
        const response = await fetch(route('cart/add.js'), {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:variantID,quantity:1}],sections:['helper-cart'],sections_url:context.pathname + context.search})
        });
        const result = await response.json();
        if (!response.ok) {
          if (response.status === 422) {
            requestSent = false;
            throw new Error(typeof result.description === 'string' ? result.description : errorText);
          }
          throw new Error(errorText);
        }
        mutationConfirmed = true;
        await renderCart(result.sections && result.sections['helper-cart']);
        announce(successText);
      } catch (error) {
        // Never blindly repeat an add after an uncertain response or failed HTML refresh.
        if (requestSent || mutationConfirmed) { goToCart(); }
        else { this.message(error.message || errorText); }
      } finally { setBusy(false); }
    }
  }
  customElements.define('cc-cart-complements', CCCartComplements);
})();
